import React from 'react'

import { Avatar, AvatarStack, Box, Card, Tag } from '@factorialco/deprecated-design-system'
import { PeopleChartGroupFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

type Props = {
  team: PeopleChartGroupFragment
  onClick: (id: string) => void
  active: boolean
}
const PeopleChartGroup: React.FC<Props> = ({ team, onClick, active }) => {
  const membersQty = team.firstMembers.totalCount || 0

  return (
    <Box
      width="s300"
      onClick={() => onClick(team.id)}
      border={
        active
          ? {
              all: {
                width: 's1',
                style: 'solid',
                color: 'grey1000',
              },
            }
          : {}
      }
      borderRadius={
        active
          ? {
              all: 'abs016',
            }
          : {}
      }
    >
      <Card>
        <Card.Eyebrow>
          <Avatar
            size="s40"
            label={team.name}
            backgroundColor="grey200"
            color="grey"
            url={buildUrl(team.avatar)}
          />
          <Tag leftItem="icon" icon="person">
            {membersQty}
          </Tag>
        </Card.Eyebrow>
        <Card.Title ellipsis>{team.name}</Card.Title>
        <Card.Content>
          {membersQty > 0 && (
            <AvatarStack
              size="s40"
              avatars={team.firstMembers.nodes.slice(0, 6).map((member) => ({
                label: member.employee?.fullName || '',
                url: buildUrl(member.employee?.access?.avatar || ''),
              }))}
              leftover={membersQty > 5 ? membersQty - 6 : 0}
              backgroundColor="grey000White"
              textSize="200"
              textColor="grey1000"
              overlap="s12"
            />
          )}
        </Card.Content>
      </Card>
    </Box>
  )
}
export default PeopleChartGroup
